import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  InputSignal,
  OnDestroy,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { StickerData } from '../../services/sticker-list-controller/sticker-list-controller';
import { StickerListControllerService } from '../../services/sticker-list-controller/sticker-list-controller.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
  selector: 'livery-editor-tool',
  imports: [CommonModule, FormsModule, MatIconModule, MatSlideToggleModule, MatTooltipModule],
  templateUrl: './livery-editor-tool.component.html',
  styleUrl: './livery-editor-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveryEditorToolComponent implements OnDestroy {
  public width: InputSignal<number> = input<number>(150);
  public editStickerIndex: InputSignal<number> = input<number>(-1);
  public endEditor: OutputEmitterRef<boolean> = output<boolean>();

  public stickerData: StickerData = {
    title: '',
    type: 'sticker',
    image: '',
    thumnail: '',
  };

  public isStickerCutMode: boolean = false;

  constructor(
    private stickerListController: StickerListControllerService,
    private canvasController: CanvasControllerService,
    private cd: ChangeDetectorRef,
  ) {
    this.getEffect();
  }

  ngOnDestroy(): void {
    this.isStickerCutMode = false;
    this.canvasController.offCutMode();
  }

  //---------------------------------------------------------------------------------
  // Public methods
  //---------------------------------------------------------------------------------

  public changeCutMode(): void {
    console.log('changeCutMode', this.isStickerCutMode);
    if (this.isStickerCutMode) this.canvasController.onCutMode(this.editStickerIndex());
    else this.canvasController.offCutMode();
  }

  public onClickDone(): void {
    this.isStickerCutMode = false;
    this.canvasController.offCutMode();
    this.endEditor.emit(true);
  }

  //---------------------------------------------------------------------------------
  // Private methods
  //---------------------------------------------------------------------------------

  private getEffect(): void {
    effect(() => {
      if (this.editStickerIndex() < 0) {
        this.stickerData = {
          title: '',
          type: 'sticker',
          image: '',
          thumnail: '',
        };
        return;
      }
      this.stickerData = this.stickerListController.attachStickers[this.editStickerIndex()];
      this.cd.markForCheck();
    });
  }
}
